import { ETipoOperacao } from "../pix/models/qr-code-return.model";

export class TransacaoBoleto {
	agencia: number;
	codigoBarras: string;
	documento: string;
	nome: string;
}

export class TransacaoCartaoDebito {
	categoriaEstabelecimento: string;
	cidadeEstabelecimento: string;
	paisEstabelecimento: string;
	nomeEstabelecimento: string;
}

export class TransacaoOriginal {
	descricao: string;
	codigoTransacaoQrCode: string;
	valor: number;
	dataTransacao: string;
}

export class TransacaoPix {
	numeroConta: number;
	tipoConta: string;
	agencia: number;
	autenticacao: string;
	complemento: string;
	documento: string;
	codigoFimAFim: string;
	codigoFimAFimDevolucao: string;
	codigoISPB: string;
	nomeISPB: string;
	nome: string;
	codigoTransacaoQrCode: string;
	transacaoOriginal: TransacaoOriginal;
	tipoOperacao: ETipoOperacao;
	medValorSolicitado: string;
	medResultadoAnalise: string;
	medDetalhes: string;
	iniciadorCNPJ: string;
	iniciadorMarca: string;
}

export class TransacaoTransferencia {
	numeroConta: number;
	agencia: number;
	autenticacao: string;
	codigoBanco: number;
	complemento: string;
	documento: string;
	codigoISPB: string;
	nomeISPB: string;
	nome: string;
}

export class Transacoes {
	dataContabil: string;
	complemento: string;
	quantidadeConsolidada: number;
	descricao: string;
	codigoDocumento: string;
	codigoHistorico: number;
	descricaoHistorico: string;
	tipoMovimentacao: string;
	transacaoBoleto: TransacaoBoleto;
	dataTransacao: Date;
	transacaoCartaoDebito: TransacaoCartaoDebito;
	transacaoPix: TransacaoPix;
	codigoTransacao: number;
	tTransacaoTransferencia: TransacaoTransferencia;
	tipoTransacao: TransactionType;
	valor: number;
	saldo: number;
}

export class BankExtract {
	balancoFinal: number;
	balancoInicial: number;
	transacoes: Transacoes[];
}

export enum TransactionType {
	PIX_ENVIADO = 'PIX_ENVIADO',
	PIX_RECEBIDO = 'PIX_RECEBIDO',
	PIX_DEVOLUCAO_ENVIADA = 'PIX_DEVOLUCAO_ENVIADA',
	PIX_DEVOLUCAO_RECEBIDA = 'PIX_DEVOLUCAO_RECEBIDA',
	TEF_ENVIADO = 'TEF_ENVIADO',
	TEF_RECEBIDO = 'TEF_RECEBIDO',
	DOC_ENVIADO = 'DOC_ENVIADO',
	DOC_RECEBIDO = 'DOC_RECEBIDO',
	TED_ENVIADO = 'TED_ENVIADO',
	TED_RECEBIDO = 'TED_RECEBIDO',
	SAQUE_CARTAO_DEBITO = 'SAQUE_CARTAO_DEBITO',
	COMPRA_CARTAO_DEBITO = 'COMPRA_CARTAO_DEBITO',
	DEPOSITO_BOLETO = 'DEPOSITO_BOLETO',
	PAGAMENTO_BOLETO_OUTRA_IF = 'PAGAMENTO_BOLETO_OUTRA_IF',
	PAGAMENTO_BOLETO_PROPRIA_IF = 'PAGAMENTO_BOLETO_PROPRIA_IF',
	PAGAMENTO_BOLETO_SPB_OUTRA_IF = 'PAGAMENTO_BOLETO_SPB_OUTRA_IF',
	PAGAMENTO_BOLETO_VIA_ABC = 'PAGAMENTO_BOLETO_VIA_ABC',
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/extract/extract.model.ts